import { Input } from '@/components/shadcn/input'
import type { PropertyEditorProps } from '@/lib/action-modules/registry/subtypes/types'

export default function IntegerPropertyEditor(props: PropertyEditorProps) {
  return (
    <Input
      type="number"
      placeholder="-"
      value={props.value === undefined || props.value === null ? '' : (props.value as number)}
      onChange={e => props.onChanged(e.target.value !== '' ? Number(e.target.value) : undefined)}
    />
  )
}
